import type { RuleHandler } from "../types";

const checkMinimumSelections: RuleHandler = (context, requirement) => {
  if (
    (requirement.userDrivenAttributes?.minimumSelections || 0) >
    (context.selection.outcomeIds?.length ?? 0)
  ) {
    return false;
  }

  return true;
};

export { checkMinimumSelections };
